
<template>
  <div class="baseIndex">
    <MdBaseBarVue class="MD"/>
    <SearchBar class="PC"/>
   </div>
</template>

<script>
// 移动
import MdBaseBarVue from './MdBaseBar.vue'
// pc端
import SearchBar from './SearchBar.vue'
export default {
  name: 'baseIndex',
  data () {
    return {
      // media: [
      //   {
      //     id: '1',
      //     name: '官方微信公众号',
      //     images: require('@/views/Base/img/weixingongzhonghao.png')
      //   },
      //   {
      //     id: '2',
      //     name: '官方抖音号',
      //     images: require('@/views/Base/img/douyinhao.png')
      //   }
      // ],
      // baseBottomList: [
      //   {
      //     id: '1',
      //     name: '官方服务热线：400-991-9533',
      //     images: require('@/views/Base/img/dianhua.png')
      //   }, {
      //     id: '2',
      //     name: '公司邮箱：zsh424@126.com',
      //     images: require('@/views/Base/img/youxiang.png')
      //   }, {
      //     id: '3',
      //     name: '地址：郑州市中科智谷12栋楼7层',
      //     images: require('@/views/Base/img/dizhi.png')
      //   }
      // ]

    }
  },
  components: {
    SearchBar,
    MdBaseBarVue
  }
}
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .baseIndex{
    .PC{
      display: none;
    }
    // margin-bottom: 110px/72/192*2;
  }

}
// PC端/
@media only screen and (min-width: 756px) {
  .baseIndex{
    .MD{
      display: none;
    }
  }
}

</style>
